import React, { useEffect, useRef } from "react";
import Helmet from "react-helmet";

/**
 * Phase-specific Kajabi form embed.
 * Similar to KajabiSubscribeEmbed but accepts formId prop for different phase forms.
 */
export default function KajabiPhaseFormEmbed({ formId, onSuccess }) {
  const formUrl = `https://www.essentialist.dev/forms/${formId}/form_submissions`;
  const formRef = useRef(null);

  useEffect(() => {
    if (!formRef.current) return;

    const handleSubmit = async (e) => {
      e.preventDefault();
      
      const form = e.target;
      const formData = new FormData(form);

      try {
        const response = await fetch(formUrl, {
          method: 'POST',
          body: formData,
          mode: 'no-cors', // Kajabi forms don't support CORS
        });

        // Since we're using no-cors, we can't check the response
        // but if no error was thrown, assume success
        if (onSuccess) {
          setTimeout(onSuccess, 500);
        }
        
        // Also dispatch the kajabi success event
        window.postMessage({ type: 'kajabi:form:success' }, '*');
      } catch (error) {
        console.error('Form submission error:', error);
      }
    };

    formRef.current.addEventListener('submit', handleSubmit);
    const currentForm = formRef.current;

    return () => {
      if (currentForm) {
        currentForm.removeEventListener('submit', handleSubmit);
      }
    };
  }, [formUrl, onSuccess]);

  return (
    <div className="kajabi-subscribe-embed">
      <Helmet>
        <link
          href="//fonts.googleapis.com/css?family=Open+Sans:400,700"
          rel="stylesheet"
          type="text/css"
        />
        <link
          rel="stylesheet"
          href="https://kajabi-app-assets.kajabi-cdn.com/assets/form_embed-16f7ab4b6a39a3561005e3bd414a039f7e8d7edd34dd2bd3a5117db001f47b8e.css"
          media="all"
        />
      </Helmet>

      <div id="kajabi-form" className="kajabi-form--inline">
        <form
          ref={formRef}
          action={formUrl}
          acceptCharset="UTF-8"
          method="post"
        >
          <input
            type="hidden"
            name="authenticity_token"
            value="PSCB+IncU4rpQi+ZzDODCGuzuhnIjN2/BR2crFlZvHB4Pp2DgG/9ubxAhqDOQZfgoS2DXoae9aQlRVQDl/iZHw=="
            autoComplete="off"
          />

          <style id="form-embed-style" type="text/css" />

          <div className="kajabi-form__content">
            <fieldset>
              <div className="name-field kajabi-form__form-item">
                <input
                  required
                  placeholder="First name"
                  type="text"
                  name="form_submission[name]"
                  id="form_submission_name"
                />
              </div>
              <div className="email-field kajabi-form__form-item">
                <input
                  required
                  placeholder="Email"
                  type="email"
                  name="form_submission[email]"
                  id="form_submission_email"
                />
              </div>
              <button
                className="kajabi-form__btn kajabi-form__btn--block-mobile"
                type="submit"
              >
                Get my results
              </button>
            </fieldset>
          </div>
        </form>
      </div>
    </div>
  );
}
